import moment from 'moment';
import * as yup from 'yup';
const { yupResolver } = require('@hookform/resolvers/yup');

export const ELegacySurveyType = [
  { label: 'ทั้งหมดที่เป็นสมาชิก', value: 'all' },
  { label: 'เฉพาะนักธุรกิจ', value: 'Distributor' },
  { label: 'เฉพาะ VIP', value: 'Member' },
  { label: 'เฉพาะรายชื่อ', value: 'group' },
  { label: 'เฉพาะรายชื่ออีเวนต์', value: 'Event' },
];

export const legacySurveyFormDefaultValues = {
  title: '',
  description: '',
  imageUrl: '',
  isPopUp: false,
  point: 0,
  startDate: moment(),
  endDate: moment(),
  display: true,
  memberType: 'all',
};

export const legacySurveyFormSchema = () => {
  return yupResolver(
    yup.object().shape({
      title: yup.string().required('กรุณากรอกข้อมูล'),
      description: yup.string().defined(),
      imageUrl: yup.string().defined(),
      point: yup
        .number()
        .min(1, 'กรุณากรอกข้อมูล')
        .typeError('กรุณากรอกข้อมูล')
        .required('กรุณากรอกข้อมูล'),
      display: yup.boolean().defined(),
      isPopUp: yup.boolean().defined(),
      startDate: yup.string().required('กรุณากรอกข้อมูล'),
      endDate: yup.string().required('กรุณากรอกข้อมูล'),
      memberType: yup.string().required('กรุณากรอกข้อมูล'),
    }),
  );
};

export const ELegacySurveyQuestionType = [
  { label: 'ตัวเลือกแบบเลือกคำตอบเดียว', value: 'select' },
  { label: 'ตัวเลือกแบบเลือกหลายคำตอบ', value: 'multi_select' },
  { label: 'บรรยายคำตอบ', value: 'text' },
];

export const ELegacySurveyQuestionCondition = [
  { label: 'ไม่กำหนด', value: 'not_fixed' },
  { label: 'ต้องตอบอย่างน้อย', value: 'more_than' },
  { label: 'ต้องตอบไม่เกิน', value: 'less_than' },
];

export const ELegacySurveyQuestionAnswerType = [
  { label: 'ข้อความ', value: 'text' },
  { label: 'ระดับคะแนน', value: 'weight' },
];

export const legacySurveyPartFormDefaultValues = {
  title: '',
};

export const legacySurveyPartFormSchema = () => {
  return yupResolver(
    yup.object().shape({
      title: yup.string().required('กรุณากรอกข้อมูล'),
    }),
  );
};

export const answerDefaultValues = [
  {
    imageUrl: '',
    answer: '',
    isOther: false,
    weight: 0,
    isComment: false,
  },
  {
    imageUrl: '',
    answer: '',
    isOther: false,
    weight: 0,
    isComment: false,
  },
  {
    imageUrl: '',
    answer: '',
    isOther: false,
    weight: 0,
    isComment: false,
  },
];

export const legacySurveyQuestionFormDefaultValues = {
  question: '',
  imageUrl: '',
  display: true,
  required: false,
  isUserAnswerText: false,
  type: 'select',
  answerType: 'text',
  answers: answerDefaultValues,
  condition: 'not_fixed',
  conditionNumber: 0,
  isHasOther: false,
  isNoAnswer: false,
};

export const legacySurveyQuestionFormSchema = () => {
  return yupResolver(
    yup.object().shape({
      question: yup.string().required('กรุณากรอกข้อมูล'),
      imageUrl: yup.string().defined('กรุณากรอกข้อมูล'),
      display: yup.boolean().defined(),
      answers: yup
        .array()
        .when('type', (type, schema) => {
          if (type !== 'text')
            return yup.array(
              yup.object().shape({
                imageUrl: yup.string().nullable(),
                answer: yup.string().required('กรุณากรอกข้อมูล'),
                isOther: yup.boolean(),
              }),
            );
          return yup.array(
            yup.object().shape({
              imageUrl: yup.string().nullable(),
              answer: yup.string().defined(),
              isOther: yup.boolean(),
            }),
          );
        })

        .required('กรุณากรอกข้อมูล'),
      type: yup.mixed().oneOf(['select', 'multi_select', 'text']).defined(),
      required: yup.boolean().defined(),
      isUserAnswerText: yup.boolean().defined(),
      isHasOther: yup.boolean().defined(),
      isNoAnswer: yup.boolean().defined(),
      condition: yup
        .mixed()
        .oneOf(['not_fixed', 'more_than', 'less_than'])
        .defined(),
      conditionNumber: yup.string().defined(),
    }),
  );
};
